module.exports = __webpack_public_path__ + "img/cs.8a8fd79f.jpg";